const MOBILE_BREAKPOINT = 769;

function isMobile() {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

function readAdvisorConfig(section) {
  return {
    descriptionMaxLength: parseInt(
      section.dataset.advisorDescriptionMaxLength || "200",
      10
    ),
    readMoreLabel: section.dataset.advisorReadMoreLabel || "More",
    readLessLabel: section.dataset.advisorReadLessLabel || "Less",
  };
}

function getPlainTextLength(element) {
  if (!element) return 0;
  return (element.textContent || "").replace(/\s+/g, " ").trim().length;
}

function setReadMoreExpanded(wrap, expanded) {
  const content = wrap.querySelector("[data-advisor-read-more-content]");
  const toggle = wrap.querySelector("[data-advisor-read-more-toggle]");
  const moreLabel = wrap.querySelector("[data-advisor-read-more-more]");
  const lessLabel = wrap.querySelector("[data-advisor-read-more-less]");

  if (!content || !toggle) return;

  content.classList.toggle("advisor-section__bio--collapsed", !expanded);
  toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
  toggle.classList.toggle("advisor-section__read-more--expanded", expanded);

  if (moreLabel) moreLabel.hidden = expanded;
  if (lessLabel) lessLabel.hidden = !expanded;
}

function updateReadMore(section) {
  const wrap = section.querySelector("[data-advisor-read-more]");
  const content = wrap?.querySelector("[data-advisor-read-more-content]");
  const toggle = wrap?.querySelector("[data-advisor-read-more-toggle]");
  const config = readAdvisorConfig(section);

  if (!wrap || !content || !toggle) return;

  if (!isMobile()) {
    toggle.hidden = true;
    content.classList.remove("advisor-section__bio--collapsed");
    toggle.setAttribute("aria-expanded", "true");
    toggle.classList.remove("advisor-section__read-more--expanded");
    return;
  }

  const needsToggle = getPlainTextLength(content) > config.descriptionMaxLength;

  if (!needsToggle) {
    toggle.hidden = true;
    content.classList.remove("advisor-section__bio--collapsed");
    toggle.setAttribute("aria-expanded", "true");
    toggle.classList.remove("advisor-section__read-more--expanded");
    return;
  }

  toggle.hidden = false;

  if (toggle.getAttribute("aria-expanded") !== "true") {
    setReadMoreExpanded(wrap, false);
  }
}

function buildReadMore(section) {
  const bio = section.querySelector(".hero__text:not(.advisor-quote)");
  if (!bio || bio.closest("[data-advisor-read-more]")) return;

  const config = readAdvisorConfig(section);
  const wrap = document.createElement("div");
  wrap.className = "advisor-section__bio-wrap";
  wrap.setAttribute("data-advisor-read-more", "");

  bio.parentNode.insertBefore(wrap, bio);
  wrap.appendChild(bio);
  bio.classList.add("advisor-section__bio");
  bio.setAttribute("data-advisor-read-more-content", "");

  const toggle = document.createElement("button");
  toggle.type = "button";
  toggle.className = "advisor-section__read-more";
  toggle.setAttribute("data-advisor-read-more-toggle", "");
  toggle.setAttribute("aria-expanded", "false");
  toggle.setAttribute("aria-label", "Toggle advisor biography");
  toggle.hidden = true;
  toggle.innerHTML =
    '<span class="advisor-section__read-more-line advisor-section__read-more-line--left" aria-hidden="true"></span>' +
    '<span class="advisor-section__read-more-center">' +
    '<span class="advisor-section__read-more-label" data-advisor-read-more-more></span>' +
    '<span class="advisor-section__read-more-label advisor-section__read-more-label--less" data-advisor-read-more-less hidden></span>' +
    '<span class="advisor-section__read-more-icon" aria-hidden="true"></span>' +
    '</span>' +
    '<span class="advisor-section__read-more-line advisor-section__read-more-line--right" aria-hidden="true"></span>';

  const moreLabel = toggle.querySelector("[data-advisor-read-more-more]");
  const lessLabel = toggle.querySelector("[data-advisor-read-more-less]");
  if (moreLabel) moreLabel.textContent = config.readMoreLabel;
  if (lessLabel) lessLabel.textContent = config.readLessLabel;

  wrap.appendChild(toggle);

  toggle.addEventListener("click", () => {
    const expanded = toggle.getAttribute("aria-expanded") === "true";
    setReadMoreExpanded(wrap, !expanded);
  });
}

function buildMobileCard(section) {
  if (section.querySelector(".advisor-section__card")) return;

  const title = section.querySelector(".hero__title");
  const bioWrap = section.querySelector(".advisor-section__bio-wrap");
  if (!title || !bioWrap) return;

  const card = document.createElement("div");
  card.className = "advisor-section__card";
  title.parentNode.insertBefore(card, title);
  card.appendChild(title);
  card.appendChild(bioWrap);
}

function getAdvisorPicture(section) {
  return (
    section.querySelector(".hero__pic-wrapper") ||
    section.querySelector(".hero__pic-container")
  );
}

function syncMobileMediaLayout(section) {
  const hero = section.querySelector(".hero");
  const quote = section.querySelector(".advisor-quote");
  const picture = getAdvisorPicture(section);
  const overlayContent = section.querySelector(".hero__overlay__content");
  const card = section.querySelector(".advisor-section__card");

  if (!hero || !quote || !picture || !overlayContent) return;

  let media = section.querySelector(".advisor-section__media");

  if (isMobile()) {
    if (!media) {
      media = document.createElement("div");
      media.className = "advisor-section__media";
      hero.insertBefore(media, hero.firstChild);
    }

    if (picture.parentElement !== media) {
      media.appendChild(picture);
    }

    if (quote.parentElement !== media) {
      media.appendChild(quote);
    }

    return;
  }

  if (quote.parentElement !== overlayContent) {
    if (card) {
      overlayContent.insertBefore(quote, card);
    } else {
      overlayContent.appendChild(quote);
    }
  }

  if (media) {
    if (picture.parentElement === media) {
      hero.insertBefore(picture, media);
    }
    media.remove();
  }
}

function initAdvisorSection(section) {
  buildReadMore(section);
  buildMobileCard(section);
  syncMobileMediaLayout(section);

  if (section.dataset.advisorInitialized !== "true") {
    section.dataset.advisorInitialized = "true";
  }

  requestAnimationFrame(() => updateReadMore(section));
}

function initAllAdvisorSections(root = document) {
  root.querySelectorAll(".advisor-section").forEach(initAdvisorSection);
}

let resizeTimer = null;

document.addEventListener("DOMContentLoaded", () => initAllAdvisorSections());

window.addEventListener(
  "resize",
  () => {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll(".advisor-section").forEach((section) => {
        syncMobileMediaLayout(section);
        updateReadMore(section);
      });
    }, 150);
  },
  { passive: true }
);

document.addEventListener("shopify:section:load", (event) => {
  initAllAdvisorSections(event.target);
});
